import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useState } from "react"

import { ThemeProvider } from "@/app/theme"
import { ApiError } from "@/api/client"
import { Toaster } from "@/components/ui/sonner"

export function Providers({ children }: { children: React.ReactNode }) {
  // El cliente se crea dentro del componente y no a nivel de módulo: a nivel de
  // módulo se compartiría entre tests y entre renders del servidor, filtrando caché
  // de una prueba a otra.
  const [qc] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: (intentos, error) => {
              // Reintentar un 401 o un 404 solo genera más 401 y más 404.
              if (error instanceof ApiError && error.status < 500) return false
              return intentos < 2
            },
          },
        },
      }),
  )

  return (
    <ThemeProvider>
      <QueryClientProvider client={qc}>
        {children}
        <Toaster richColors closeButton />
      </QueryClientProvider>
    </ThemeProvider>
  )
}
